package one.primehealth.app

data class BaseAppConfig(
    val baseUrls: BaseUrls,
    val intercomApiKey: PlatformValues<String>,
    val intercomAppKey: String,
    val intercomAppName: String,
    val amplitudeKey: String,
    val adaptyKey: String,
    val appsflyerKey: String,
    val appleAppId: String,
    val feedbackEmail: String,
    val features: Features = Features(),
    val firebaseApp: FirebaseAppConfig,
    val appId: String,
    val subscriptionManagementUrl: String = "https://app.healthium.one/subscription",
)

data class BaseUrls(
    val content: String,
)

data class Features(
    val mealPlansEnabled: Boolean = true,
    val periodTrackerEnabled: Boolean = false,
    val personalMealPlanEnabled: Boolean = false,
    val rateAppEnabled: PlatformValues<Boolean> = PlatformValues.createMobileOnly(),
    val healthKitEnabled: PlatformValues<Boolean> = PlatformValues.createMobileOnly(),
    val remindersEnabled: PlatformValues<Boolean> = PlatformValues.createMobileOnly(),
)

data class FirebaseAppConfig(
    val applicationId: String,
    val apiKey: String,
    val projectId: String,
    val storageBucket: String,
    val userStorageBucket: String,
    val authDomain: String,
)
